import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import productData from '../product.json';

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const allProducts = productData.categories.flatMap(category =>
      category.products.map(p => ({
        ...p,
        categoryName: category.name.zh,
        categoryId: category.id
      }))
    );
    const foundProduct = allProducts.find(p => p.id === id);
    setProduct(foundProduct);
  }, [id]);

  if (!product) {
    return (
      <main className="pt-[60px] py-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-3xl font-bold mb-4">产品未找到</h1>
          <p className="text-on-surface-variant mb-8">请检查产品链接是否正确</p>
          <Link to="/products" className="inline-block bg-primary text-on-primary px-6 py-3 text-sm font-bold uppercase tracking-wider hover:bg-primary-container transition-colors duration-200 rounded">
            返回产品中心
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="pt-[60px]">
      {/* Header */}
      <section className="py-16 bg-surface-bright">
        <div className="container mx-auto px-6">
          <div className="flex items-center mb-6">
            <Link to="/products" className="text-primary hover:underline mr-4">
              <span className="material-symbols-outlined">arrow_back</span>
            </Link>
            <h1 className="text-3xl md:text-4xl font-bold text-on-surface">{product.name.zh}</h1>
          </div>
          <p className="text-on-surface-variant mb-8">{product.categoryName}</p>
        </div>
      </section>

      {/* Product Image */}
      <section className="bg-surface-container-low py-8">
        <div className="container mx-auto px-6">
          <div className="bg-white rounded-lg overflow-hidden shadow-sm">
            <img 
              src={product.image} 
              alt={product.name.zh} 
              className="w-full h-80 object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Product Description */}
      <section className="py-16 bg-surface-bright">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold text-on-surface mb-6">产品介绍</h2>
            <p className="text-on-surface-variant mb-8">{product.description.zh}</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="bg-surface-container rounded-lg p-6">
                <h3 className="text-lg font-semibold text-on-surface mb-4">技术参数</h3>
                <p className="text-on-surface-variant">{product.specs.zh}</p>
              </div>
              <div className="bg-surface-container rounded-lg p-6">
                <h3 className="text-lg font-semibold text-on-surface mb-4">应用领域</h3>
                <div className="flex flex-wrap gap-2">
                  {product.applications.map((app, index) => (
                    <span key={index} className="px-3 py-1 bg-surface text-sm text-on-surface-variant rounded">{app}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 bg-surface-container-low border-t border-gray-200">
        <div className="container mx-auto px-6">
          <div className="flex flex-col items-center justify-center gap-4">
            <p className="text-on-surface-variant text-sm">© 2024 SILANOL. 上海氟聚新材料科技有限公司. All Rights Reserved.</p>
            <p className="text-on-surface-variant text-sm">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="hover:underline">
                沪ICP备2024055979号
              </a>
            </p>
          </div>
        </div>
      </footer>
    </main>
  );
};

export default ProductDetail;